import {
    IStatsCard,
    IServerDashboardStats,
    DASHBOARD_TIME_RANGES,
    IServerNotification,
    IClientNotification,
    AlertSeverity,
    convertIsoDateToDDMMNYYYY,
    IClientAssignment,
    IServerAssignment,
    AssignmentPriority,
} from '../../../common';
import i18next from 'i18next';

export const formatStatsObject = (
    stats: IServerDashboardStats
): Record<string, Array<IStatsCard>> => {
    return {
        [DASHBOARD_TIME_RANGES.WEEK]: [
            {
                title: i18next.t('dashboardPage.openPositions'),
                value: stats.open_positions_7_days_total,
                change: {
                    value: stats.applications_in_progress_7_days_change,
                    isPositive:
                        stats.applications_in_progress_7_days_change !== null
                            ? stats.applications_in_progress_7_days_change > 0
                            : false,
                    isZero:
                        stats.applications_in_progress_7_days_change !== null
                            ? stats.applications_in_progress_7_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.newResumes'),
                value: stats.new_resumes_7_days_total,
                change: {
                    value: stats.new_resumes_7_days_change,
                    isPositive:
                        stats.new_resumes_7_days_change !== null
                            ? stats.new_resumes_7_days_change > 0
                            : false,
                    isZero:
                        stats.new_resumes_7_days_change !== null
                            ? stats.new_resumes_7_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.applicationsInProgress'),
                value: stats.applications_in_progress_7_days_total,
                change: {
                    value: stats.applications_in_progress_7_days_change,
                    isPositive:
                        stats.applications_in_progress_7_days_change !== null
                            ? stats.applications_in_progress_7_days_change > 0
                            : false,
                    isZero:
                        stats.applications_in_progress_7_days_change !== null
                            ? stats.applications_in_progress_7_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.successRate'),
                value: null,
                change: {
                    value: 0,
                    isPositive: false,
                    isZero: true,
                },
            },
        ],
        [DASHBOARD_TIME_RANGES.MONTH]: [
            {
                title: i18next.t('dashboardPage.openPositions'),
                value: stats.open_positions_30_days_total,
                change: {
                    value: stats.open_positions_30_days_change,
                    isPositive:
                        stats.open_positions_30_days_change !== null
                            ? stats.open_positions_30_days_change > 0
                            : false,
                    isZero:
                        stats.open_positions_30_days_change !== null
                            ? stats.open_positions_30_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.newResumes'),
                value: stats.new_resumes_30_days_total,
                change: {
                    value: stats.new_resumes_30_days_change,
                    isPositive:
                        stats.new_resumes_30_days_change !== null
                            ? stats.new_resumes_30_days_change > 0
                            : false,
                    isZero:
                        stats.new_resumes_30_days_change !== null
                            ? stats.new_resumes_30_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.applicationsInProgress'),
                value: stats.applications_in_progress_30_days_total,
                change: {
                    value: stats.applications_in_progress_30_days_change,
                    isPositive:
                        stats.applications_in_progress_30_days_change !== null
                            ? stats.applications_in_progress_30_days_change > 0
                            : false,
                    isZero:
                        stats.applications_in_progress_30_days_change !== null
                            ? stats.applications_in_progress_30_days_change ===
                              0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.successRate'),
                value: null,
                change: {
                    value: 0,
                    isPositive: false,
                    isZero: true,
                },
            },
        ],
        [DASHBOARD_TIME_RANGES.QUARTER]: [
            {
                title: i18next.t('dashboardPage.openPositions'),
                value: stats.open_positions_90_days_total,
                change: {
                    value: stats.open_positions_90_days_change,
                    isPositive:
                        stats.open_positions_90_days_change !== null
                            ? stats.open_positions_90_days_change > 0
                            : false,
                    isZero:
                        stats.open_positions_90_days_change !== null
                            ? stats.open_positions_90_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.newResumes'),
                value: stats.new_resumes_90_days_total,
                change: {
                    value: stats.new_resumes_90_days_change,
                    isPositive:
                        stats.new_resumes_90_days_change !== null
                            ? stats.new_resumes_90_days_change > 0
                            : false,
                    isZero:
                        stats.new_resumes_90_days_change !== null
                            ? stats.new_resumes_90_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.applicationsInProgress'),
                value: stats.applications_in_progress_90_days_total,
                change: {
                    value: stats.applications_in_progress_90_days_change,
                    isPositive:
                        stats.applications_in_progress_90_days_change !== null
                            ? stats.applications_in_progress_90_days_change > 0
                            : false,
                    isZero:
                        stats.applications_in_progress_90_days_change !== null
                            ? stats.applications_in_progress_90_days_change ===
                              0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.successRate'),
                value: null,
                change: {
                    value: 0,
                    isPositive: false,
                    isZero: true,
                },
            },
        ],
        [DASHBOARD_TIME_RANGES.YEAR]: [
            {
                title: i18next.t('dashboardPage.openPositions'),
                value: stats.open_positions_365_days_total,
                change: {
                    value: stats.open_positions_365_days_change,
                    isPositive:
                        stats.open_positions_365_days_change !== null
                            ? stats.open_positions_365_days_change > 0
                            : false,
                    isZero:
                        stats.open_positions_365_days_change !== null
                            ? stats.open_positions_365_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.newResumes'),
                value: stats.new_resumes_365_days_total,
                change: {
                    value: stats.new_resumes_365_days_change,
                    isPositive:
                        stats.new_resumes_365_days_change !== null
                            ? stats.new_resumes_365_days_change > 0
                            : false,
                    isZero:
                        stats.new_resumes_365_days_change !== null
                            ? stats.new_resumes_365_days_change === 0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.applicationsInProgress'),
                value: stats.applications_in_progress_365_days_total,
                change: {
                    value: stats.applications_in_progress_365_days_change,
                    isPositive:
                        stats.applications_in_progress_365_days_change !== null
                            ? stats.applications_in_progress_365_days_change > 0
                            : false,
                    isZero:
                        stats.applications_in_progress_365_days_change !== null
                            ? stats.applications_in_progress_365_days_change ===
                              0
                            : true,
                },
            },
            {
                title: i18next.t('dashboardPage.successRate'),
                value: null,
                change: {
                    value: 0,
                    isPositive: false,
                    isZero: true,
                },
            },
        ],
    };
};

const convertNotificationSeverity = (severity: string): AlertSeverity => {
    switch (severity) {
        case 'LOW':
            return AlertSeverity.INFO;
        case 'MEDIUM':
            return AlertSeverity.WARNING;
        case 'HIGH':
            return AlertSeverity.ERROR;
        default:
            return AlertSeverity.INFO;
    }
};

export const formatNotificationsObject = (
    notifications: Array<IServerNotification>
): Array<IClientNotification> => {
    return notifications.map((notification) => ({
        id: notification.id.toString(),
        date: convertIsoDateToDDMMNYYYY(notification.created_at),
        description: notification.message,
        severity: convertNotificationSeverity(notification.priority),
    }));
};

export const formatAssignmentsObject = (
    assignments: Array<IServerAssignment>
): Array<IClientAssignment> => {
    return assignments?.map((assignment) => ({
        id: assignment.id,
        title: assignment.title ?? '',
        description: assignment.description ?? '',
        isCompleted: assignment.is_complete ?? false,
        dueDate: assignment.due_date ?? '',
        priority: assignment.priority ?? AssignmentPriority.LOW,
        duration: assignment.duration ?? null,
    }));
};

export const formatAssignmentObject = (
    assignment: IServerAssignment
): IClientAssignment => {
    return {
        id: assignment.id,
        title: assignment.title ?? '',
        description: assignment.description ?? '',
        isCompleted: assignment.is_complete ?? false,
        dueDate: assignment.due_date ?? '',
        priority: assignment.priority ?? AssignmentPriority.LOW,
        duration: assignment.duration ?? null,
    };
};

export const formatAssignmentPayload = (
    assignment: IClientAssignment
): IServerAssignment => {
    return {
        id: assignment.id,
        title: assignment.title,
        description: assignment.description,
        due_date: assignment.dueDate,
        is_complete: assignment.isCompleted,
        priority: assignment.priority as AssignmentPriority,
        duration: assignment.duration,
    };
};
